import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Header from "../../layouts/headers/pages/LogsHeaderLayout";
import Page from "../../layouts/pages/PageLayout";
import useAuthState from "../../services/hooks/useAuthState.hook";
import BeatLoader from "react-spinners/BeatLoader";

const getLogs = async (user, setRows) => {
    const rows = await user.getLogs();
    setRows(rows);
};

export default props => {
    const [user, initializing, authError] = useAuthState();
    const [rows, setRows] = useState([]);
    useEffect(() => {
        if (!initializing && user) {
            getLogs(user, setRows);
        }
    }, [user, initializing]);
    return (
        <Page header={<Header auth={[user, initializing]} />}>
            <Grid container justify="center" alignItems="center">
                {authError || initializing ? <Typography variant="h5" color="secondary"> Must be authenticated.</Typography> :
                    <Grid item xs={12} lg={8}>
                        <TableContainer style={{
                            maxHeight: 440
                        }} component={Paper}>
                            <Table className="table" stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date / Time</TableCell>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Reserved By</TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell>Vehicle Brand</TableCell>
                                        <TableCell>Vehicle Color</TableCell>
                                        <TableCell>Vehicle License Plates</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows !== [] ? rows.map(row => (
                                        <TableRow key={row.id}>
                                            <TableCell component="td" scope="row">
                                                {moment.unix(row.timestamp.seconds).format('HH:mm:ss DD/MM/YYYY')}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.action}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.type}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.reservedBy.name} {row.reservedBy.lastName} - {row.reservedBy.id}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.user.name} {row.user.lastName} - {row.user.id}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.vehicle.vehicle}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.vehicle.color}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row.vehicle.plates}
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan="8" component="td" scope="row">
                                                <div style={{height: 50}}><BeatLoader /></div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                }
            </Grid>
        </Page>
    );
};